<template>
  <el-row justify="space-around">
    <el-col :span="12">
      <div style="padding: 10px">
        <!-- お客様情報 -->
        <div class="wrapper_border" style="min-height: 310px; padding: 10px">
          <span class="pi_title_color"> お客様情報</span>
          <div style="margin-top: 5px">
            <template>
              <el-row>
                <!-- <el-col :span="4"> -->
                  <!-- <img
                    v-if="$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE'"
                    class="img_questioner1"
                    :src="this.$store.state.sysInit.pi_phone_questioner_logo" />
                  <img
                    v-else
                    class="img_questioner1"
                    :src="this.$store.state.sysInit.pi_chat_questioner_logo" />
                  <br /> -->
                  <!-- <span style="margin-left: 23px">
                    <icon name="star"></icon>
                    <icon name="star"></icon>
                  </span> -->
                <!-- </el-col> -->
                <el-col :span="24">
                  <el-table
                    :data="this.$store.state.sysInit.customerInfo3"
                    style="width: 100%; font-size: 12px"
                    height="310px"
                    :show-header="false"
                    :cell-style="cellStyle"
                    :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                    <el-table-column prop="label" label="" width="130" />
                    <el-table-column prop="value" label="" width="320">
                      <template slot-scope="scope">
                        <span v-if="scope.row.label=='生年月日*'">
                          <span v-if="scope.row.value">{{scope.row.value}}</span>
                        </span>
                        <span v-else>{{scope.row.value}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
        <!-- 相性診断 -->
        <div class="wrapper_border" style="min-height: 214px; margin-top: 10px">
          <template>
            <div v-if="this.$store.state.sysInit.piEmptyFlg" style="padding: 10px">
              <p style="margin-top: 50px; text-align: center; font-size: 20px">
                {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
              </p>
            </div>
            <div v-else style="padding: 10px">
              <el-row>
                <div><span class="pi_title_color">直近３件のお問い合わせ履歴</span>
                <template v-if="this.$store.state.sysInit.piIssueListEmptyFlg">
                  <div style="height: 96.7%">
                    <div style="padding-bottom: 90px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 97.6%">
                    <div style="padding: 5px"></div>
                    <div style="padding: 0px">
                      クレーム検知：0件 長時間通話：{{
                        this.$store.state.sysInit.longTimeCount
                      }}件 NGワード：{{ this.$store.state.sysInit.ngCount }}件
                    </div>
                    <el-table
                      :data="this.$store.state.sysInit.PiIssueList.slice(0, 3)"
                      style="width: 100%; margin-left: 0px"
                      height="138px"
                      border
                      :cell-style="cellStyle3"
                      :header-cell-style="{
                        color: '#FFFFFF',
                        background: '#53BCE5',
                      }"
                      :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                      <el-table-column width="70%" align="center">
                        <template slot="header"> # </template>
                        <template slot-scope="scope">
                          <span></span>
                          <!-- <a href="https://aicc-dev-redmine.mybluemix.net/issues/" target="_blank">{{ scope.row.issue_id }}</a> -->
                          <a
                            style="color: #5ed4ff"
                            target="_blank"
                            :href="
                              $store.state.sysInit.html_const.cons_272_redmine_url +
                              scope.row.issue_id
                            "
                            >{{ scope.row.issue_id }}</a
                          >
                        </template>
                      </el-table-column>
                      <!-- <el-table-column prop="issue_id" label="#">
                      </el-table-column> -->
                      <el-table-column
                        prop="category_tag"
                        label="カテゴリ"
                        align="center"
                        width="99%"
                        class-name="td-is-left">
                      </el-table-column>
                      <el-table-column
                        prop="subject_name"
                        label="タイトル"
                        align="center"
                        width="95%"
                        class-name="td-is-left">
                      </el-table-column>
                      <el-table-column prop="name" label="担当者" width="90%" align="center">
                      </el-table-column>
                      <el-table-column prop="finish_time" label="作成日" width="90%" align="center">
                        <template slot-scope="scope">
                          <span>{{scope.row.finish_time.replaceAll("-","/")}}</span>
                        </template>
                      </el-table-column>
                      
                    </el-table>
                    <!-- </div> -->
                  </div>
                </template>
                </div>
              </el-row>
            </div>
          </template>
        </div>
      </div>
    </el-col>
    <!-- 直前の応対引継ぎ情報 -->
    <el-col :span="12">
      <div
        v-if="$store.state.sysInit.searchDetail_issue_tracker == ''"
        class="wrapper_border"
        style="padding: 10px; margin-top: 10px; margin-right: 10px; min-height: 579px">
        <p style="margin-top: 200px; text-align: center; font-size: 20px">
          "左のお問い合わせ者リストから選択してください。"
          <!-- {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }} -->
        </p>
      </div>
      <div
        v-else
        class="wrapper_border"
        style="padding: 10px; margin-top: 10px; margin-right: 10px; min-height: 579px">
        <el-row>
          <div style="width: 100%">
            <span class="pi_title_color">直前の応対引継ぎ情報</span>
            <div v-if="$store.state.sysInit.searchDetail_issue_tracker == 'AI CHATBOT'">
              <div style="width: 100%; padding-top: 3px">
                <span> お問い合わせカテゴリ：</span>
                <span
                  v-if="
                    $store.state.sysInit.searchDetail_issue_tracker == 'AI CHATBOT' &&
                    $store.state.sysInit.searchDetail_issue_category != ''
                  ">
                  <el-tag class="el-tag2" type="warning">{{
                    $store.state.sysInit.searchDetail_issue_category
                  }}</el-tag>
                </span>
              </div>
            </div>
            <!-- add for AI ASSISTANT-->
            <div style="padding-top:10px" v-else-if="$store.state.sysInit.searchDetail_issue_tracker == 'AI ASSISTANT'"></div>
            <!-- TODO start 以后这个部分要查询相关的数据，做成时点相关功能未完成 -->
            <div v-else>
              <div style="width: 100%; padding-top: 3px">
                <span>直前回線：</span>
                <span>03-6667-1111 (製品サポートデスク)</span>
              </div>
              <div style="width: 100%; padding-top: 3px">
                <span> 着信スキル：</span>
                <span style="margin-right: 3px">
                  <el-tag class="el-tag2" type="warning">日本語</el-tag>
                </span>
                <span style="margin-right: 3px">
                  <el-tag class="el-tag2" type="info">新製品</el-tag>
                </span>
                <span style="margin-right: 3px">
                  <el-tag class="el-tag2">予約注文</el-tag>
                </span>
              </div>
            </div>
            <!-- TODO end 以后这个部分要查询相关的数据，做成时点相关功能未完成 -->
            <div style="width: 100%; padding-top: 3px; display: flex">
              <div style="width: 10%">
                <img
                  :src="$store.state.sysInit.searchDetail_issue_system_logo"
                  style="height: 40px" 
                  :style="$store.state.sysInit.searchDetail_issue_tracker == 'AI ASSISTANT' ? 'border-radius: 50%;':''"/>
              </div>
              <div style="width: 80%; padding-top: 5px">
                <div style="width: 100%">
                  <span v-if="$store.state.sysInit.searchDetail_issue_tracker == 'AI ASSISTANT'" style ="margin-right: 5px;">{{this.$store.state.sysInit.searchDetail_issue_system_num}}</span>
                  <span>{{this.$store.state.sysInit.searchDetail_issue_system_name}}</span>
                  <span v-if="$store.state.sysInit.searchDetail_issue_tracker == 'AI ASSISTANT'">
                    {{ this.$store.state.sysInit.searchDetail_issue_channel == 'CHAT SUPPORT'? '（チャットサポート）': '（電話サポート）'}}
                  </span>
                </div>
                <div style="width: 100%">
                  {{
                    $store.state.sysInit.manualChatbotAllTextList.length > 0
                      ? $store.state.sysInit.manualChatbotAllTextList[0].messageTime.replaceAll("-","/")
                      : "-"
                  }}
                </div>
              </div>
            </div>
            <div
              style="width: 100%; padding-top: 3px; display: flex; height: 50px; overflow-y: auto">
              <div style="width: 21%">カテゴリタグ:</div>
              <div style="width: 75%">
                <span
                  v-for="(menu, index) in this.$store.state.sysInit.manualChatbotCategoryTag"
                  v-if="index < 3"
                  style="padding: 5px">
                  <el-tag class="el-tag2" type="success">{{ menu }}</el-tag>
                </span>
                <span
                  style="padding: 5px"
                  v-if="this.$store.state.sysInit.manualChatbotCategoryTag.length > 3">
                  <el-tag class="el-tag2" type="info">
                    + {{ this.$store.state.sysInit.manualChatbotCategoryTag.length - 3 }}</el-tag
                  >
                </span>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <el-table
              :data="data"
              :key="timeStamp"
              :show-header="false"
              :height="issueDetailHeight"
              :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
              <el-table-column>
                <template slot-scope="scope">
                  <div
                    style="padding-right: 5px"
                    class="message_msg_chat"
                    :class="{
                      left: scope.row.flag == 'right',
                      right: scope.row.flag == 'left',
                    }">
                    <div class="user_headshot" style="background-color: #f2f2f2">
                       <img :src="scope.row.logoUrl">
                      <!-- <img :src="scope.row.logoUrl" v-if="scope.row.flag == 'right'" />
                      <img
                        v-if="
                          $store.state.sysInit.searchDetail_issue_tracker == 'AI CHATBOT' &&
                          scope.row.flag == 'left'
                        "
                        src="../assets/img/moppy1.png" />
                      <img v-else src="../assets/img/AIvoicebot.png" /> -->
                    </div>
                    <div class="user_msg">
                      <span>
                        <div class="speaker">
                          {{ scope.row.username }}
                        </div>
                        <div class="user_text" style="min-height: 28px; min-width: 30px;">
                          <span class="content-img-width" v-html="scope.row.text"></span>
                        </div>
                      </span>
                      <br />
                      <div v-if="scope.row.flag == 'right'" style="font-size: 12px; float: left">
                        {{ scope.row.messageTime.replaceAll("-","/") }}
                      </div>
                      <div v-else style="font-size: 12px; float: right">
                        {{ scope.row.messageTime.replaceAll("-","/") }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
const watson_logo = require("@/assets/img/moppy1.png");
export default {
  data() {
    return {
      data: this.$store.state.sysInit.manualChatbotAllTextList,
      timeStamp: new Date().getTime()
    };
  },
  watch: {
    "$store.state.sysInit.manualChatbotAllTextList": function () {
      this.data = this.$store.state.sysInit.manualChatbotAllTextList;
      this.timeStamp = new Date().getTime();
    },
  },
  computed:{
    issueDetailHeight(){
      return this.$store.state.sysInit.searchDetail_issue_tracker == 'AI CHATBOT' ? '252px' : this.$store.state.sysInit.searchDetail_issue_tracker == 'AI ASSISTANT' ? '418px': '386px'
    }

  },
  methods: {
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (columnIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#4DB1EC ; color:#FFFFFF;padding-left:5px";
      } else if (columnIndex === 1) {
        if (rowIndex % 2 == 1) {
          return "height:25px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:25px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
      }
    },
    cellStyle3({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (rowIndex % 2 == 1) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#E6E6E6";
      } else {
        return "background:#F2F2F2";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-img-width ::v-deep(img) {
  width: 100%;
}
#img_head_back_left_bottom {
  background-color: #ff56a7;
  position: absolute;
  width: 50px;
  left: 169px;
  z-index: 10;
}
.img_heart_left_bottom {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 60px;
  left: 169px;
  z-index: 20;
}
</style>
